import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64baa833&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64baa833",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-airdrop-manager-fe/treasurenet-tnservices-airdrop-manager-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64baa833')) {
      api.createRecord('64baa833', component.options)
    } else {
      api.reload('64baa833', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64baa833&scoped=true", function () {
      api.rerender('64baa833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingBtn/index.vue"
export default component.exports